import { render } from "./TestDetail.vue?vue&type=template&id=11f8a7bf&scoped=true"
import script from "./TestDetail.vue?vue&type=script&lang=js"
export * from "./TestDetail.vue?vue&type=script&lang=js"

import "./TestDetail.vue?vue&type=style&index=0&id=11f8a7bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f8a7bf"]])

export default __exports__